var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 285,
    viewBox: "0 0 287 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M12.6865 240.403L4.85652 239.589L5.0076 238.137L11.2399 238.785L11.2939 231.717L18.3247 232.449L18.3824 225.379L25.4132 226.109L25.4672 219.043L32.4995 219.773L32.5571 212.704L39.5916 213.432L39.6558 206.357L47.4924 207.162L47.3428 208.614L41.101 207.973L41.0367 215.049L34.0037 214.321L33.9461 221.391L26.9145 220.661L26.8605 227.727L19.829 226.996L19.7713 234.067L12.7413 233.335L12.6865 240.403Z",
    fill: "url(#paint0_linear_5_5753)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M277.704 121.218L263.194 121.289L263.201 122.749L277.711 122.678L277.704 121.218Z",
    fill: "url(#paint1_linear_5_5753)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M271.14 114.741L269.68 114.748L269.748 129.26L271.208 129.253L271.14 114.741Z",
    fill: "url(#paint2_linear_5_5753)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M233.648 93.4893L233.106 92.134L238.924 89.8064L235.683 83.5259L242.246 80.9013L239.008 74.6172L245.57 71.9911L242.33 65.7121L248.894 63.0853L245.655 56.8011L252.22 54.1721L248.984 47.88L256.295 44.9459L256.839 46.3005L251.016 48.6376L254.251 54.9305L247.687 57.5594L250.927 63.8443L244.364 66.4704L247.604 72.7502L241.041 75.3755L244.28 81.6604L237.717 84.285L240.958 90.5647L233.648 93.4893Z",
    fill: "url(#paint3_linear_5_5753)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M98.613 268.243C93.1872 268.243 88.7737 263.828 88.7737 258.403C88.7737 252.977 93.1879 248.563 98.613 248.563C104.038 248.563 108.453 252.977 108.453 258.403C108.453 263.828 104.039 268.243 98.613 268.243ZM98.613 250.022C93.9922 250.022 90.2334 253.781 90.2334 258.402C90.2334 263.023 93.9929 266.782 98.613 266.782C103.233 266.782 106.993 263.023 106.993 258.402C106.993 253.781 103.234 250.022 98.613 250.022Z",
    fill: "url(#paint4_linear_5_5753)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M154.766 245.959L140.256 246.03L140.263 247.49L154.774 247.419L154.766 245.959Z",
    fill: "url(#paint5_linear_5_5753)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M148.196 239.475L146.736 239.482L146.805 253.993L148.264 253.986L148.196 239.475Z",
    fill: "url(#paint6_linear_5_5753)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M63.386 75.8278L48.8764 75.8987L48.8835 77.3584L63.3931 77.2875L63.386 75.8278Z",
    fill: "url(#paint7_linear_5_5753)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M56.8254 69.3382L55.3657 69.345L55.4341 83.8568L56.8938 83.8499L56.8254 69.3382Z",
    fill: "url(#paint8_linear_5_5753)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M198.139 31.612L196.253 14.8579L213.007 12.9719L214.893 29.726L198.139 31.612ZM197.867 16.1454L199.426 29.9982L213.279 28.4385L211.72 14.5856L197.867 16.1454Z",
    fill: "url(#paint9_linear_5_5753)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M213.036 260.27L206.662 244.661L222.271 238.288L228.645 253.896L213.036 260.27ZM208.566 245.461L213.836 258.368L226.742 253.097L221.472 240.191L208.566 245.461Z",
    fill: "url(#paint10_linear_5_5753)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M178.203 278.34C178.203 281.631 175.535 284.3 172.244 284.3C168.953 284.3 166.285 281.631 166.285 278.34C166.285 275.049 168.953 272.381 172.244 272.381C175.535 272.381 178.203 275.049 178.203 278.34Z",
    fill: "url(#paint11_linear_5_5753)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M20.3698 44.7649C20.3698 47.9851 17.7591 50.5965 14.5382 50.5965C11.3173 50.5965 8.70657 47.9851 8.70657 44.7649C8.70657 41.5447 11.3173 38.9333 14.5382 38.9333C17.7591 38.9333 20.3698 41.5447 20.3698 44.7649Z",
    fill: "url(#paint12_linear_5_5753)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M43.7015 179.796C43.7015 183.087 41.0331 185.755 37.7421 185.755C34.4511 185.755 31.7835 183.087 31.7835 179.796C31.7835 176.505 34.4511 173.837 37.7421 173.837C41.0331 173.837 43.7015 176.505 43.7015 179.796Z",
    fill: "url(#paint13_linear_5_5753)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M103.064 50.5608C103.064 53.0321 101.06 55.0363 98.5882 55.0363C96.1161 55.0363 94.1134 53.0321 94.1134 50.5608C94.1134 48.0894 96.1169 46.0852 98.5882 46.0852C101.06 46.0852 103.064 48.0894 103.064 50.5608Z",
    fill: "url(#paint14_linear_5_5753)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M263.224 6.48982L248.714 6.56073L248.721 8.02045L263.232 7.94953L263.224 6.48982Z",
    fill: "url(#paint15_linear_5_5753)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M256.666 0.0109435L255.206 0.0178223L255.275 14.5296L256.734 14.5227L256.666 0.0109435Z",
    fill: "url(#paint16_linear_5_5753)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M286.877 44.7729C286.877 48.0639 284.209 50.7323 280.918 50.7323C277.627 50.7323 274.959 48.0639 274.959 44.7729C274.959 41.482 277.627 38.8136 280.918 38.8136C284.209 38.8136 286.877 41.482 286.877 44.7729Z",
    fill: "url(#paint17_linear_5_5753)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.314 123.023H76.9976V212.71H210.314V123.023Z",
    fill: "#7540D3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M145.99 77.4542C145.148 76.7659 144.256 76.6206 143.656 76.6206C143.056 76.6206 142.162 76.7652 141.32 77.4542L85.583 123.023V188.268C85.583 197.89 93.3831 205.69 103.005 205.69H184.305C193.927 205.69 201.727 197.89 201.727 188.268V123.023L145.99 77.4542Z",
    fill: "#5538C3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M145.99 77.4542C145.148 76.7659 144.256 76.6206 143.656 76.6206C143.056 76.6206 142.162 76.7652 141.32 77.4542L89.1075 120.142C86.8771 121.966 85.583 124.695 85.583 127.576V205.69H201.727V127.576C201.727 124.694 200.433 121.965 198.203 120.142L145.99 77.4542Z",
    fill: "#5538C3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M142.221 69.6979L76.9968 123.023H210.313L145.088 69.6979C144.254 69.0162 143.055 69.0162 142.221 69.6979H142.221Z",
    fill: "#7540D3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M204.707 78.8212V185.097C204.723 187.367 202.024 189.216 198.679 189.227L92.3496 189.558C89.0046 189.568 86.2808 187.736 86.2654 185.466L85.5735 83.1033C85.5582 80.8334 88.2572 78.9847 91.6022 78.9737L173.33 78.719C174.957 78.7139 203.563 78.0366 204.707 78.8212Z",
    fill: "#EBEBEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 103.585H188.165",
    stroke: "#CAD2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 114.756H188.165",
    stroke: "#CAD2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 125.925H188.165",
    stroke: "#CAD2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 137.096H188.165",
    stroke: "#CAD2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 148.267H188.165",
    stroke: "#CAD2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 159.436H188.165",
    stroke: "#CAD2C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.934 170.607H188.165",
    stroke: "#CAD2C5",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M129.787 180.308L76.9976 212.71V123.023L129.787 155.425C139.069 161.122 139.069 174.611 129.787 180.309V180.308Z",
    fill: "#7540D3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.524 180.308L210.314 212.71V123.023L157.524 155.425C148.242 161.122 148.242 174.611 157.524 180.309V180.308Z",
    fill: "#7540D3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M142.221 159.385L76.9969 212.71H210.313L145.088 159.385C144.254 158.703 143.055 158.703 142.221 159.385H142.221Z",
    fill: "#5538C3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_5753",
    x1: 15.324,
    y1: 217.868,
    x2: 37.0197,
    y2: 228.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_5753",
    x1: 263.193,
    y1: 121.986,
    x2: 277.71,
    y2: 121.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3162B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#305DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2A37A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#282DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#282BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_5753",
    x1: 269.687,
    y1: 121.985,
    x2: 271.216,
    y2: 121.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3162B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#305DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2A37A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#282DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#282BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_5753",
    x1: 232.808,
    y1: 69.3715,
    x2: 257.15,
    y2: 69.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_5753",
    x1: 91.6581,
    y1: 265.358,
    x2: 105.568,
    y2: 251.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E958E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D655E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B351E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#964DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#804AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7048EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6647F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6447F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_5753",
    x1: 140.255,
    y1: 246.725,
    x2: 154.772,
    y2: 246.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_5753",
    x1: 146.75,
    y1: 246.725,
    x2: 148.279,
    y2: 246.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_5753",
    x1: 48.8759,
    y1: 76.5934,
    x2: 63.3929,
    y2: 76.5934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_5753",
    x1: 55.371,
    y1: 76.5929,
    x2: 56.8994,
    y2: 76.5929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_5753",
    x1: 202.561,
    y1: 32.8718,
    x2: 208.543,
    y2: 11.7186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_5753",
    x1: 217.654,
    y1: 260.273,
    x2: 217.655,
    y2: 238.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_5753",
    x1: 166.285,
    y1: 278.34,
    x2: 178.203,
    y2: 278.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E958E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D755E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B550E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9F4DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#984CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#964BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8049EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7048EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6647F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6447F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5_5753",
    x1: 8.70657,
    y1: 44.7649,
    x2: 20.3698,
    y2: 44.7649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E958E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D755E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B550E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9F4DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#984CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#964BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8049EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7048EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6647F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6447F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5_5753",
    x1: 31.7828,
    y1: 179.796,
    x2: 43.7015,
    y2: 179.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E958E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D755E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B550E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9F4DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#984CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#964BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8049EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7048EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6647F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6447F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5_5753",
    x1: 94.1134,
    y1: 50.5608,
    x2: 103.064,
    y2: 50.5608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E954CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#E95BAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#EA6289"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EB696C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#EC6D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#EC7146"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EC733C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5_5753",
    x1: 248.714,
    y1: 7.25559,
    x2: 263.231,
    y2: 7.25559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3162B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#305DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2A37A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#282DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#282BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5_5753",
    x1: 255.208,
    y1: 7.25565,
    x2: 256.736,
    y2: 7.25565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3162B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#305DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2C47AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#2A37A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#282DA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#282BA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5_5753",
    x1: 274.958,
    y1: 44.7729,
    x2: 286.877,
    y2: 44.7729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E958E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D755E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#B550E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#9F4DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#984CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#964BEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#8049EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#7048EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#6647F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6447F1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMessages);
export default __webpack_public_path__ + "static/media/empty-messages.7d7ba433a90dec161e3967c8c8a7c89e.svg";
export { ForwardRef as ReactComponent };